<div *ngIf="url" class="embed-container" [style.max-width]="sectionWidth + 'px'">
  <app-embed-display [url]="url"></app-embed-display>
</div>
